import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DataManagementIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DataManagement",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.29 16C9.88 16 4.86 13.11 4.86 9.43s5.02-6.57 11.43-6.57 11.43 2.89 11.43 6.57S22.7 16 16.29 16m0-10.86c-5.39 0-9.14 2.26-9.14 4.29s3.76 4.29 9.14 4.29 9.14-2.26 9.14-4.29-3.76-4.29-9.14-4.29"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.29 22.29c-6.41 0-11.43-2.89-11.43-6.57a1.14 1.14 0 1 1 2.28 0c0 2.03 3.76 4.29 9.14 4.29s9.14-2.26 9.14-4.29a1.14 1.14 0 1 1 2.28 0c0 3.69-5.02 6.57-11.43 6.57Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.29 28.57c-6.41 0-11.43-2.89-11.43-6.57V9.14a1.14 1.14 0 1 1 2.28 0V22c0 2.03 3.76 4.29 9.14 4.29s9.14-2.26 9.14-4.29a1.14 1.14 0 1 1 2.28 0c0 3.69-5.02 6.57-11.43 6.57Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.57 22.86c-.63 0-1.14-.51-1.14-1.14V9.43a1.14 1.14 0 1 1 2.28 0v12.29c0 .63-.51 1.14-1.14 1.14"
    })]
  }));
};
DataManagementIcon.displayName = 'DataManagementIcon';